import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Row, Column } from '@xingternal/malt-grid';
import Textlink from '@xingternal/malt-textlink';

import { CustomH, CustomP } from './../../Components/CustomMalt/Typography';
import Spacer from './../../Components/Spacer/Spacer';

import messages from './messages';
import styles from './Logout.css';

const buildLink = (to, message) => (
  <Textlink data-qa={'malt-login-again-link'} to={to}>
    <FormattedMessage {...message} />
  </Textlink>
);

const View = ({ greetingKey }) => (
  <>
    <Spacer size={8} />
    <Row style={{ minHeight: '75vh' }}>
      <Column size={12} className={styles.centerChildren}>
        <CustomH>
          <FormattedMessage {...messages[greetingKey]} />
        </CustomH>
        <CustomP>
          <FormattedMessage
            {...messages.comeback}
            values={{
              loginLink: buildLink('/', messages.loginLinkText),
            }}
          />
        </CustomP>
      </Column>
    </Row>
  </>
);

export default View;
